/**
 * @name: fetch.js
 * @description: 请求方法定义
 * @author: 温永江
 * @create: 2020/07/22 14:13:01
 * @update: 2020/07/22 14:13:01
 */
import Vue from 'vue';
// import main from '@/main.js';
import router from '@/router/';
import axios from 'axios';
// eslint-disable-next-line
import { stringify } from 'qs';

const time = 3000;
const getToken = async () => {
  const login = await Vue.lf.getItem('login');
  if (login) {
    return login.token;
  }
  return null;
};
const goLogin = () => {
  // 跳转登录页方法
  Vue.controller.login();
};
let Token = '';
axios.interceptors.request.use(
  config => {
    // 发送请求之前做一些处理
    const isFd = config.type.toLowerCase() == 'formdata';
    let myConfig = config;
    // 当数据时formData类型时，不要对config.data做任何普通对象的处理
    // 保持其formData的类型不变
    if ((myConfig.data) == '[object Object]') {
      for (let key in myConfig.data) {
        if (myConfig.data[key] === undefined) {
          myConfig.data[key] = '';
        }
      }
      let tem = JSON.parse(JSON.stringify(myConfig.data));
      myConfig.data = {};
      myConfig.data = tem;
    }
    return getToken().then(token => {
      // if (!!token && !isFd) {
      //   myConfig.data = { ...myConfig.data };
      // } else if (isFd) myConfig.data.append('token', token);
      myConfig.headers = {
        'Content-Type': 'application/json',
        token
        // 'Content-Type': 'application/x-www-form-urlencoded'
      };
      // 处理formdata
      if (config.type.toLowerCase() == 'formdata') {
        // myConfig.headers = {
        //   'Content-Type': 'multipart/form-data'
        // };
        myConfig.headers['Content-Type'] = 'multipart/form-data';
      }
      // console.log(config)
      myConfig.baseURL = config.baseUrl || window.__CONFIG__.url; // 网站接口前缀
      myConfig.method = 'POST';
      // config.data.token =
      //   config.data.token ||
      //   localStorage.token ||
      //   parse(url.parse(location.href).query).token
      myConfig.timeout = 50000;
      // if (router.currentRoute.name == "login") {
      //   delete config.data.token
      // }
      if (config.type.toLowerCase() != 'formdata') {
        // myConfig.data = stringify(config.data);
      } else {
      }
      return myConfig;
    });
  },
  error => {
    // 当请求异常时做一些处理
    console.log('请求出错');

    return Promise.reject(error);
  }
);

// 响应时拦截
axios.interceptors.response.use(
  response =>
    // 返回响应时做一些处理
    response,
  error => {
    if (!error.response) {
      Vue.tips({
        content: '网络中断，请检查！',
        type: 'error'
      }).hide(time);
    }
    Vue.loading().hide();
    return Promise.reject(error);
  }
);

export default function ({
  baseUrl,
  api,
  para = {},
  loading = false,
  loadingText = '加载中...',
  type = 'json',
  isSuccessTip = false,
  isBlob = false,
  filename = '',
  progressCallback = () => { }
}) {
  return getToken().then(token => {
    Token = token;
    // 前置处理：如果检测到token为空，则不发请求，直接回登陆页
    if (!Token && router.currentRoute.name !== 'login') {
      // Vue.lf.removeItem('keepQuickMenu').then(goLogin);
    }
    if (loading) {
      Vue.loading({
        content: loadingText
      }).show();
    }
    return new Promise((resolve, reject) => {
      let setting = {
        method: 'post',
        baseUrl,
        url: api,
        data: para,
        type
      };
      if (isBlob) {
        setting.responseType = 'blob';
      }
      // formdata 上传数据是否做进度显示处理
      if (type.toLowerCase() == 'formdata' && typeof progressCallback == 'function') {
        setting.onUploadProgress = progressCallback;
      }
      // console.log(para);

      axios(setting)
        .then(res => {
          loading && Vue.loading().hide();
          if (isBlob) {
            const blob = new Blob([res.data]);
            const downloadElement = document.createElement('a');
            const href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download = `${filename}.xlsx`; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
            resolve();
          } else {
            switch (parseInt(res.data.code)) {
              case 200:
                if (type.toLowerCase() == 'formdata') {
                  resolve(res.data);
                } else {
                  resolve(res.data.data);
                }
                if (isSuccessTip && res.data.message) {
                  Vue.tips({
                    content: res.data.message,
                    type: 'success'
                  })
                    .show()
                    .hide(time);
                }
                // 记录最近一次请求响应成功的时间
                Vue.lf.setItem('recentlyResponseTime', new Date() - 0);
                break;
              case 401:
                Vue.tips({
                  content: res.data.message,
                  type: 'error'
                })
                  .show()
                  .hide(time);
                reject(res);
                Vue.lf.getItem('recentlyResponseTime').then(t => {
                  if (t) {
                    const d = new Date() - t;
                    // 如果大于2小时，则不保留快捷页签
                    if (d > 2 * 3600 * 1000) {
                      Vue.lf.removeItem('keepQuickMenu').then(goLogin);
                    } else {
                      Vue.lf.setItem('keepQuickMenu', 1).then(goLogin);
                    }
                  } else {
                    goLogin();
                  }
                });
                break;
              default:
                Vue.tips({
                  content: res.data.message,
                  type: 'error'
                }).hide(time);
                reject(res.data.Msg);
            }
          }
        })
        .catch(err => {
          Vue.tips({
            content: '网络出现问题，请检查！',
            type: 'error'
          }).hide(time);
          reject(err);
        });
    });
  });
}
